import React, { useRef } from 'react'
import { AppInputField, AppInputFieldBtn, InputFieldTitleText } from '../../../../../widget/styledComponents/input_field.style'
import Cookies from 'js-cookie';
import {useHistory } from 'react-router-dom';
import { gql, useMutation } from '@apollo/client';
import { toaster } from 'evergreen-ui';


export const UPDATA_PROFILE = gql`
mutation FacilityManager_updateProfile($name: String, $password: String) {
  facilityManager_updateProfile(name: $name, password: $password) {
    code
    success
    error
    data {
      _id
      email
      name
      phone
      createdAt
      id
    }
    token
  }
}
`;


function ProfileTab() {
const history = useHistory()
const accesTokenValue = Cookies.get('userAccessToken');
const userEmailValue = Cookies.get('userEmail');
const userNamelValue = Cookies.get('userName');



const [updateProfile, { loading }] = useMutation(UPDATA_PROFILE);

const handleSubmit=(e)=>{
    e.preventDefault()
    updateProfile({
        variables: { 
            name: nameRef.current.value,
            password:passwordRef.current.value
        },
        context: {
        headers: {
            Authorization: `Bearer ${accesTokenValue}`,
        },
        },
    })
    .then((response) => {
        toaster.success("Profile updated.")
        history.push(`/`);
    })
    .catch((error) => {
        toaster.danger(error.message)
    });
    }
    
    const nameRef = useRef(userNamelValue);
    const passwordRef = useRef(null);
  return (
    <div>
        <div className='row'>
            <div className='col s12 l5'>
                <form onSubmit={handleSubmit}>
                    <InputFieldTitleText>
                        Name
                    </InputFieldTitleText>
                    <AppInputField type='text' value={userNamelValue} ref={nameRef}></AppInputField>
                    <InputFieldTitleText>
                        Email
                    </InputFieldTitleText>
                    <AppInputField type='email' value={userEmailValue} disabled></AppInputField>
                    <InputFieldTitleText>
                        Password
                    </InputFieldTitleText>
                    <AppInputField type='text' ref={passwordRef}></AppInputField>
                    <AppInputFieldBtn className='mt-25' disabled={loading}>
                        Submit
                    </AppInputFieldBtn>
                </form>
            </div>
            <div className='col s12 l7'></div>
        </div>
    </div>
  )
}

export default ProfileTab